import React, { useMemo } from 'react';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Markup from 'components/Markup';
import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';
import { useTrans } from 'utils/localisation';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './Industries.module.scss';

function Industries({ title, subtitle, items }) {
  const t = useTrans(['industries']);

  const defaultData = useMemo(
    () => ({
      title: t('title'),
      items: t('items'),
    }),
    [],
  );

  const { title: defaultTitle, items: defaultItems } = defaultData;
  const preparedItems = items ?? defaultItems;

  return (
    <Container id="industries">
      <div className={styles.wrapper}>
        <Title tag="h2">{title ?? defaultTitle}</Title>
        {subtitle && (
          <Markup className={styles.subtitle} tag="p">
            {subtitle}
          </Markup>
        )}
        <DesktopLayout items={preparedItems} />
        <MobileLayout items={preparedItems} />
      </div>
    </Container>
  );
}

Industries.displayName = 'Industries';

export default withErrorBoundary(Industries);
